// extracted by mini-css-extract-plugin
var _1 = "Task_button__nPMMB";
var _2 = "Task_buttonCard__inpga";
var _3 = "Task_contentHoverable__pRz3W";
var _4 = "Task_dueDate__fYYk2";
var _5 = "Task_dueDateCard__-UUNF";
var _6 = "Task_icon__uWr1i";
var _7 = "Task_itemCompleted__1Bs8O";
var _8 = "Task_member__GYsXw";
var _9 = "Task_members__2lA35";
var _a = "Task_moreMembers__KwuZv";
var _b = "Task_moreMembersCard__O5gaM";
var _c = "Task_target__6Z+FV";
var _d = "Task_task__j-4kw";
var _e = "Task_taskCompleted__Vb26q";
var _f = "Task_taskEditable__Tl0dl";
var _10 = "Task_wrapper__iYyQq";
export { _1 as "button", _2 as "buttonCard", _3 as "contentHoverable", _4 as "dueDate", _5 as "dueDateCard", _6 as "icon", _7 as "itemCompleted", _8 as "member", _9 as "members", _a as "moreMembers", _b as "moreMembersCard", _c as "target", _d as "task", _e as "taskCompleted", _f as "taskEditable", _10 as "wrapper" }
